module.exports = "/src/views/business/autoshop/assets/image.png";